module.exports = __webpack_public_path__ + "static/media/bag-white.181e00ab.png";